
/**
 * basically for a given selection, we want to 
 * the lightbox to be rendered below the selection &
 * starting at the center point of the selection
 * 
 * Since we're using createPortal to render at document.body,
 * we need viewport-relative coordinates, not editor-relative ones.
 */
export const getAnnoLightboxPosition = ({editor}) => {
    const domSelection = window.getSelection();
    const editorHTMLNode = editor.getRootElement();
    if(domSelection.rangeCount === 0) return ({x: 0, y: 0})
    let selectionRect = domSelection.getRangeAt(0).getBoundingClientRect();
    let editorRect = editorHTMLNode && editorHTMLNode.getBoundingClientRect();
    const centerXOfSelection = selectionRect.x + selectionRect.width / 2;
    
    // Return viewport-relative coordinates for createPortal
    return ({
      x: centerXOfSelection, 
      y: selectionRect.bottom + 5, 
    }) 
  }